import { render, staticRenderFns } from "./LiveRoomManage.vue?vue&type=template&id=59e54130&scoped=true"
import script from "./LiveRoomManage.vue?vue&type=script&lang=js"
export * from "./LiveRoomManage.vue?vue&type=script&lang=js"
import style0 from "./LiveRoomManage.vue?vue&type=style&index=0&id=59e54130&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e54130",
  null
  
)

export default component.exports